module.exports = __webpack_public_path__ + "media/photo/lady-283d2f98.png";